import { Content } from "antd/lib/layout/layout";
import BianatHeader from "../../components/BianatHeader";
import HighLights from "../../pages/home/components/Highlights";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import BianatFooter from "../../components/BianatFooter";
import {
    Card,
    Button,
    Form,
    Input,
    Typography,
    Space,
    Divider,
    message,
    Row,
    Col,
    Modal
} from "antd";
import {
    LockOutlined,
    EyeInvisibleOutlined,
    EyeTwoTone
} from "@ant-design/icons";
import { createUserWithEmailAndPassword, signInWithEmailAndPassword, updatePassword } from "firebase/auth";
import { authChatBot, dbChatBot } from "../../utils/firebase/config";
import { collection, doc, getDocs, query, setDoc, updateDoc, where } from "firebase/firestore";
import { useNavigate } from "react-router-dom";
import { FirebaseError } from "firebase/app";

const { Title, Text } = Typography;

// Separate Modal Component
const ProfileUpdateModal = ({ visible, onContinue, currentTheme, i18n }) => {
    return (
        <Modal
            className={`sub-modal ${currentTheme === "Dark" && "dark-skin"}`}
            open={visible}
            footer={null}
            closable={false}
            centered
            width={500}
        >
            <div style={{ padding: '40px 20px', textAlign: 'center' }}>
                <div style={{ marginBottom: '24px' }}>
                    <img
                        src="/assets/pUpdateImg.png"
                        alt="Profile Update"
                        style={{
                            width: '50%',
                            maxWidth: '200px',
                            margin: '0 auto',
                            display: 'block'
                        }}
                    />
                </div>
                <Title level={4} style={{ marginBottom: '16px' }} className="text-white">
                    {i18n.language === "en" ? "Account Migration Required" : "مطلوب ترحيل الحساب"}
                </Title>
                <Text style={{ fontSize: '16px', lineHeight: '1.6' }} className="text-white">
                    {i18n.language === "en"
                        ? "To continue accessing your account, please update your password. This is required as we have migrated to a new database system."
                        : "للاستمرار في الوصول إلى حسابك، يرجى تحديث كلمة المرور الخاصة بك. هذا الإجراء مطلوب لأننا قمنا بالانتقال إلى نظام قاعدة بيانات جديد"}
                </Text>
                <div style={{ marginTop: '32px', textAlign: 'right' }}>
                    <Button
                        type="primary"
                        size="large"
                        onClick={onContinue}
                    >
                        {i18n.language === "en" ? "Continue" : "استمر"}
                    </Button>
                </div>
            </div>
        </Modal>
    );
};

const TempProfileUpdate = () => {
    const navigate = useNavigate();
    const [form] = Form.useForm();
    const [isGuideOpen, setIsGuideOpen] = useState(false);
    const { t, i18n } = useTranslation();
    const currentTheme = useSelector((state) => state.currentTheme.currentTheme);

    // Variables
    const [userData, setUserData] = useState(null);
    const [showTempModal, setShowTempModal] = useState(true);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        console.log("HERE MATE");
        let userData = localStorage.getItem("temp_data");
        if (userData) {
            const userDataParsed = JSON.parse(userData);
            setUserData(userDataParsed.content);
        } else {
            navigate('/');
        }
    }, [navigate]);

    useEffect(() => {
        if (userData && form) {

            form.setFieldsValue({
                name: userData.name,
                email: userData.email,
                phone: '',
                password: '',
                confirmPassword: '',
                currentPassword: "1234569010"
            });

        }
    }, [userData, form]);

    const handleSubmit = async (values) => {
        const { name, email, phone, password } = values;
        const username = email.split("@")[0].toLowerCase();

        const dataToSave = {
            name,
            phone: {
                dialCode: "+966",
                number: phone.slice(4),
            },
            email,
            password,
            roles: ["user"],
            username,
        };

        setLoading(true);
        try {
            // Try to create the user
            const userCredential = await createUserWithEmailAndPassword(
                authChatBot,
                email,
                password
            );

            const user = userCredential.user;
            let paymentDocumentId = null;

            // Check payments collection
            const paymentsQuery = query(
                collection(dbChatBot, "payments"),
                where("userId", "==", username)
            );

            const paymentSnapshot = await getDocs(paymentsQuery);

            if (!paymentSnapshot.empty) {
                for (const doc of paymentSnapshot.docs) {
                    await updateDoc(doc.ref, { userId: user.uid });
                    paymentDocumentId = doc.id;
                }
                console.log("Payment document updated.");
            }

            // Save user in 'users' collection
            const usersRef = doc(dbChatBot, "users", user.uid);
            await setDoc(usersRef, {
                ...dataToSave,
                id: user.uid,
                subscription: paymentDocumentId ? "paid" : "free",
                paymentId: paymentDocumentId,
            });

            message.success("Profile created successfully");
            navigate("/dashboard");

        } catch (error) {
            console.log(error);
            if (error instanceof FirebaseError) {
                if (error.code === "auth/email-already-in-use") {
                    try {
                        // If user already exists, sign in and update password
                        const existingUser = await signInWithEmailAndPassword(
                            authChatBot,
                            email,
                            password
                        );

                        await updatePassword(existingUser.user, password);

                        message.success("Password updated successfully");
                        navigate("/dashboard");
                    } catch (updateError) {
                        console.log(updateError);
                        message.error("Failed to update password");
                    }
                } else {
                    message.error(error.message);
                }
            } else {
                message.error("Something went wrong");
            }
        } finally {
            setLoading(false);
        }
    };

    const handleModalContinue = () => {
        setShowTempModal(false);
    };

    return (
        <div className="h-full">
            <BianatHeader setIsGuideOpen={setIsGuideOpen} followUpPage={"true"} />
            <Content
                className={`landing-content min-h-[100vh] ${i18n.language === "en" ? "font-loader-en" : "font-loader"
                    } ${currentTheme === "Dark" && "dark-skin"}`}
            >
                <div className="live-update-toolbar">
                    <HighLights />
                </div>

                <div style={{ padding: '40px 20px' }}>
                    <Row justify="center">
                        <Col xs={24} sm={20} md={16} lg={12} xl={10}>
                            <Card
                                className="content-card"
                                style={{
                                    boxShadow: '0 4px 12px rgba(0,0,0,0.1)',
                                    borderRadius: '12px'
                                }}
                                bodyStyle={{ padding: '40px' }}
                            >
                                <div style={{ textAlign: 'center', marginBottom: '32px' }}>
                                    <Title level={2} style={{ marginBottom: '8px' }} className="text-white">
                                        {i18n.language === "en" ? "Update Profile" : "تحديث الملف الشخصي"}
                                    </Title>
                                    <Text className="text-white">
                                        {i18n.language === "en"
                                            ? "Please complete your profile information"
                                            : "يرجى إكمال معلومات ملفك الشخصي"
                                        }
                                    </Text>
                                </div>

                                <Form
                                    form={form}
                                    layout="vertical"
                                    onFinish={handleSubmit}
                                    size="large"
                                    requiredMark={false}
                                >
                                    {/* Personal Information Section */}
                                    <Title level={5} style={{ marginBottom: '16px', color: '#1890ff' }}>
                                        {i18n.language === "en" ? "Personal Information" : "المعلومات الشخصية"}
                                    </Title>

                                    <Form.Item
                                        name="name"
                                        label={i18n.language === "en" ? "Full Name" : "الاسم الكامل"}
                                        rules={[
                                            { required: true, message: 'Please enter your name' },
                                            { min: 2, message: 'Name must be at least 2 characters' }
                                        ]}
                                        style={{ marginBottom: '16px' }}
                                    >
                                        <Input
                                            placeholder={i18n.language === "en" ? "Enter your full name" : "أدخل اسمك الكامل"}
                                            style={{ height: '40px' }}
                                        />
                                    </Form.Item>

                                    <Form.Item
                                        name="email"
                                        label={i18n.language === "en" ? "Email Address" : "البريد الإلكتروني"}
                                        style={{ marginBottom: '16px' }}
                                    >
                                        <Input
                                            readOnly
                                            style={{
                                                backgroundColor: '#f5f5f5',
                                                cursor: 'not-allowed',
                                                height: '40px'
                                            }}
                                        />
                                    </Form.Item>

                                    <Form.Item
                                        name="phone"
                                        label={i18n.language === "en" ? "Phone Number" : "رقم الهاتف"}
                                        rules={[
                                            { required: true, message: 'Please enter your phone number' },
                                            {
                                                pattern: /^\+966\d{9}$/,
                                                message: 'Phone number must be in format +966XXXXXXXXX'
                                            }
                                        ]}
                                        style={{ marginBottom: '16px' }}
                                    >
                                        <Input
                                            placeholder="+966123456789"
                                            maxLength={13}
                                            style={{ height: '40px' }}
                                        />
                                    </Form.Item>

                                    <Divider style={{ margin: '32px 0' }} />

                                    {/* Security Section */}
                                    <Title level={5} style={{ marginBottom: '16px', color: '#1890ff' }}>
                                        {i18n.language === "en" ? "Security Settings" : "إعدادات الأمان"}
                                    </Title>

                                    <Form.Item
                                        name="currentPassword"
                                        label={i18n.language === "en" ? "Current Password" : "كلمة المرور الحالية"}
                                        style={{ marginBottom: '16px' }}
                                    >
                                        <Input
                                            value="123123123"
                                            readOnly
                                            type="password"
                                            style={{ height: '40px' }}

                                        />
                                    </Form.Item>

                                    <Form.Item
                                        name="password"
                                        label={i18n.language === "en" ? "New Password" : "كلمة المرور الجديدة"}
                                        rules={[
                                            { required: true, message: 'Please enter your password' },
                                            {
                                                pattern: /^(?=.*[A-Za-z])(?=.*\d)[A-Za-z\d]{8,}$/,
                                                message: 'Password must be at least 8 characters with letters and numbers'
                                            }
                                        ]}
                                        hasFeedback
                                        style={{ marginBottom: '16px' }}
                                    >
                                        <Input.Password
                                            placeholder={i18n.language === "en" ? "Enter new password" : "أدخل كلمة المرور الجديدة"}
                                            iconRender={(visible) => (visible ? <EyeTwoTone /> : <EyeInvisibleOutlined />)}
                                            style={{ height: '40px' }}
                                        />
                                    </Form.Item>

                                    <Form.Item
                                        name="confirmPassword"
                                        label={i18n.language === "en" ? "Confirm Password" : "تأكيد كلمة المرور"}
                                        dependencies={['password']}
                                        rules={[
                                            { required: true, message: 'Please confirm your password' },
                                            ({ getFieldValue }) => ({
                                                validator(_, value) {
                                                    if (!value || getFieldValue('password') === value) {
                                                        return Promise.resolve();
                                                    }
                                                    return Promise.reject(new Error('Passwords do not match'));
                                                },
                                            }),
                                        ]}
                                        hasFeedback
                                        style={{ marginBottom: '16px' }}
                                    >
                                        <Input.Password
                                            placeholder={i18n.language === "en" ? "Confirm your password" : "أكد كلمة المرور"}
                                            iconRender={(visible) => (visible ? <EyeTwoTone /> : <EyeInvisibleOutlined />)}
                                            style={{ height: '40px' }}
                                        />
                                    </Form.Item>

                                    <Form.Item style={{ marginTop: '32px', marginBottom: 0 }}>
                                        <Button
                                            type="primary"
                                            htmlType="submit"
                                            loading={loading}
                                            size="large"
                                            block
                                            style={{ height: '48px', borderRadius: '8px' }}
                                        >
                                            {loading
                                                ? (i18n.language === "en" ? "Updating..." : "جاري التحديث...")
                                                : (i18n.language === "en" ? "Update Profile" : "تحديث الملف الشخصي")
                                            }
                                        </Button>
                                    </Form.Item>
                                </Form>
                            </Card>
                        </Col>
                    </Row>
                </div>

                <ProfileUpdateModal
                    visible={showTempModal}
                    onContinue={handleModalContinue}
                    currentTheme={currentTheme}
                    i18n={i18n}
                />

                <BianatFooter />
            </Content>
        </div>
    );
};

export default TempProfileUpdate;
